module.exports = __webpack_public_path__ + "assets/46a015314d1a056a32fb8559ddcb2ace.mp3";